import { alpha, Box, Button, Card, IconButton, Modal, Typography } from '@mui/material';
import ErrorIcon from '@mui/icons-material/Error';
import { colors } from 'Constants/Colors';
import CloseIcon from '@mui/icons-material/Close';
import styled from '@emotion/styled';
import useTranslation from 'Hooks/useTranslation';
import Fade from '@mui/material/Fade';

// === emotion components ===
const CardContainer = styled(Card)`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
  width: 600px;
  height: 300px;
`;

const TitleContainer = styled(Box)`
  display: flex;
  align-items: center;
  gap: 20px;
  width: 100%;
  justify-content: space-between;
`;

const ContentContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const WarningAndTitle = ({ title }: { title: string }) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
      <Box
        sx={{
          display: 'flex',
          backgroundColor: alpha(colors.RED, 0.1),
          borderRadius: '10px',
          alignItems: 'center',
          justifyContent: 'center',
          width: '60px',
          height: '60px',
        }}
      >
        <ErrorIcon sx={{ color: colors.RED, width: '30px', height: '30px' }} />
      </Box>
      <Typography sx={{ fontSize: '18px', fontWeight: 'bold' }}>{title}</Typography>
    </Box>
  );
};

interface Props {
  open: boolean;
  onAccept: () => void;
  onClose: () => void;
  onCancel: () => void;
}

const ResetProgressModal = ({ open, onAccept, onClose, onCancel }: Props) => {
  const { t2 } = useTranslation('EmployeeAssess');

  return (
    <Modal
      open={open}
      onClose={onClose}
      closeAfterTransition
      sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
    >
      <Fade in={open} timeout={366}>
        <CardContainer>
          <ContentContainer>
            <TitleContainer>
              <WarningAndTitle title={t2('reset_progress_modal.title')} />
              <IconButton onClick={onClose}>
                <CloseIcon />
              </IconButton>
            </TitleContainer>
            <Typography variant="body1" sx={{ color: colors.BLACK_50 }}>
              {t2('reset_progress_modal.content')}
            </Typography>
          </ContentContainer>
          <Box sx={{ display: 'flex', gap: '20px', justifyContent: 'flex-end' }}>
            <Button variant="outlined" color="error" onClick={onCancel}>
              {t2('reset_progress_modal.cancel')}
            </Button>
            <Button variant="contained" color="error" onClick={onAccept}>
              {t2('reset_progress_modal.accept')}
            </Button>
          </Box>
        </CardContainer>
      </Fade>
    </Modal>
  );
};

export default ResetProgressModal;
